<template>
  <div class="page-container">
    <div class="login-container">
      <img src="../assets/full.svg" class="logo" />
      <div class="login-text">Log in</div>

      <v-form v-model="isFormValid">
        <!-- all input elements go here -->
        <div class="email-container">
          <v-text-field v-model="email" ref="email" autocomplete="username" label="Email" :rules="emailRules" hide-details="auto"></v-text-field>
        </div>
        <div class="password-container">
          <v-text-field v-model="password" autocomplete="current-password" :type="showPassword ? 'text' : 'password'" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassword = !showPassword" ref="password" label="Password" :rules="passwordRules" hide-details="auto"></v-text-field>
        </div>
        <a class="forgot-password-container" @click="$router.push('forgotpassword')"> Forgot password? </a>

        <v-btn :disabled="!isFormValid || loading" :loading="loading" @click="submit" class="login-button" color="#5774E7" width="300px" height="38px" type="submit"> Log in </v-btn>
      </v-form>

      <div class="bottom-container"><span class="text">Don't have an account? </span><a class="sign-up" @click="$router.push('signup')">Sign up now!</a></div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "Login",
  data: () => ({
    loading: false,
    email: "",
    password: "",
    isFormValid: true,
    showPassword: false,
    emailRules: [
      (value) => !!value || "Required.",
      (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
    ],
    passwordRules: [(value) => !!value || "Required."],
  }),

  mounted() {

  },
  methods: {
    async submit() {
      this.loading = true;

      const data = { email: this.email, password: this.password };
      const url = this.$store.state.serverURL + "/users/login";
      await axios
        .post(url, data, { withCredentials: true })
        .then((res) => {
          this.loading = false;
          this.$store.state.loggedIn = true;

          this.$toast.success(res.data, { position: "bottom-right", timeout: 7500 });
          this.$router.push("/pipeline");
        })
        .catch((err) => {
          this.loading = false;
          if (err.response.data == "Email not verified") {
            this.$router.push("/resendverification")
          } 
          else{
            this.$toast.error(err.request.responseText, { position: "bottom-right", timeout: 7500 });
          }
        });

      this.$store.state.isAdmin = await this.$store.state.networkHandler.checkisAdmin();
    },
    clear() {
      this.email = "";
      this.password = "";
    },
  },
};
</script>

<style scoped>
.page-container {
  width: 100%;
  height: 100%;
  display: flex;
}

.login-container {
  width: 380px;
  height: 450px;
  position: absolute;
  top: calc(50% - 225px);
  left: calc(50% - 190px);
  background-color: white;
  box-shadow: 0px 2px 4px rgba(0, 41, 199, 0.2);
  border-radius: 4px;
  display: flex;
  justify-content: center;
}

.login-text {
  position: absolute;

  top: calc(50% - 32px / 2 - 101px);

  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 26px;
  line-height: 32px;
  /* identical to box height, or 133% */

  text-align: center;

  color: #202060;
}

.logo {
  position: absolute;
  top: 40px;
}

.password-container {
  position: absolute;
  top: 240px;
  width: 300px;
}

.email-container {
  position: absolute;
  top: 170px;

  width: 300px;
}

.forgot-password-container {
  position: absolute;
  height: 16px;
  top: 310px;

  /* Link */

  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 16px;
  /* identical to box height, or 123% */

  /* Indigo / 400 */
  display: flex;
  justify-content: center;
  width: 300px;

  color: #5774e7;
}

.login-button {
  color: white;
  border-radius: 4px;
  top: 340px;
}

.bottom-container {
  width: 270px;
  position: absolute;

  position: absolute;
  height: 16px;

  top: calc(50% - 16px / 2 + 185px);

  /* Link */

  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 16px;
  /* identical to box height, or 123% */

  text-align: center;

  /* Grey / 400 */

  color: #808080;
}

a.sign-up {
  color: #5774e7;
  font-weight: 500;
}
</style>
